import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { Option } from "../../../../types/General/Option";
import { AuthUser } from "../../../../types/User/AuthUser";

interface IndicatorSelectComponent {
  fieldNameObject: string;
  options: Option[];
  fieldName: string;
  width: string;
  control: any;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  isDisabled?: boolean;
  defaultValue?: string | number | null;
  isRequired: boolean;
  isLoaded: boolean;
}

export const indicatorAnalysisSelectFilterData = (
  indicatorOptions: Option[],
  levelOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setSelectedIndicator: Dispatch<SetStateAction<Option | null>>,
  setSelectedLevel: Dispatch<SetStateAction<Option | null>>,
  selectedIndicator: Option | null,
  indicatorLoaded: boolean,
  levelLoaded: boolean,
  user: AuthUser,
): IndicatorSelectComponent[] => {
  const handleIndicatorChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedIndicatorId = e.target.value;
    const selected = indicatorOptions.find(
      (p) => p.id && p.id.toString() === selectedIndicatorId,
    );

    setSelectedIndicator(selected || null);
    setFilter("IndicatorId", selectedIndicatorId);

    if (user?.role?.level !== undefined && user?.role.level.id < 4) {
      setSelectedLevel(null);
      setFilter("IndicatorLevelId", "");
    }
  };

  const handleLevelChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedLevelId = e.target.value;
    const selected = levelOptions.find(
      (p) => p.id.toString() === selectedLevelId,
    );
    setSelectedLevel(selected || null);
    setFilter("IndicatorLevelId", selectedLevelId);
  };

  return [
    {
      fieldNameObject: "IndicatorId",
      options: indicatorOptions,
      fieldName: "Seleccione indicador",
      width: "100%",
      control: control,
      onChange: handleIndicatorChange,
      isRequired: true,
      isLoaded: indicatorLoaded,
    },
    {
      fieldNameObject: "IndicatorLevelId",
      options: levelOptions,
      fieldName: "Seleccione o nível",
      width: "100%",
      control: control,
      onChange: handleLevelChange,
      isRequired: true,
      isDisabled:
        (user?.role?.level !== undefined && user?.role.level.id >= 4) ||
        !selectedIndicator,
      defaultValue:
        user?.role?.level !== undefined && user?.role.level.id === 4
          ? 4
          : user?.role?.level?.id === 5
            ? 3
            : "",
      isLoaded: levelLoaded,
    },
  ];
};
